export const TypeSender = {
  tutor: "Trixie",
};
